import styled from "styled-components";
import WhiskymofoLogoImage from "../../images/whiskymofo-logo.png";
import { Box, Logo, Text, Image } from "@vinomofo/components";

const LogoContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 40px;
`;

const StyledLogoImage = styled(Image)`
  max-width: 200px;
  height: auto;
`;

const PoweredByText = styled(Text)`
  font-size: 12px;
  color: #fff;
  margin-top: 5px;
  display: flex;
  align-items: start;
  justify-content: start;
  gap: 5px;

  svg {
    height: 20px;
    width: auto;
  }
`;

export const WhiskymofoLogo = () => {
  return (
    <LogoContainer>
      <StyledLogoImage src={WhiskymofoLogoImage} alt="WhiskyMofo Logo" />
      <PoweredByText>
        POWERED BY <Logo />
      </PoweredByText>
    </LogoContainer>
  );
};
